import React, { Component } from 'react';
import resizeManager from '../utilities/resize-manager';
import { getRandomKey } from '../utilities/helpers';

const ResizeManager = resizeManager();

export const withWindow = ComposedComponent => class extends Component {
  constructor() {
    super();

    // Get Initial State
    this.state = {
      breakpoint: ResizeManager.getCurrentBreakpoint(),
      breakpointNewDesign: ResizeManager.getCurrentBreakpointNewDesign(),
      orientation: ResizeManager.getCurrentOrientation(),
      dimensions: ResizeManager.getCurrentDimensions(),
      key: getRandomKey(),
      isPrint: ResizeManager.getIsPrint(),
    };
  }

  componentDidMount() {
    ResizeManager.removeBreakpointListeners();
    ResizeManager.addBreakpointListeners();
    ResizeManager.subscribe(this.state.key, ({ breakpoint, breakpointNewDesign, orientation, dimensions, isPrint }) => {
      const newState = {};

      if (this.state.breakpoint !== breakpoint) {
        newState.breakpoint = breakpoint;
      }

      if (this.state.breakpointNewDesign !== breakpointNewDesign) {
        newState.breakpointNewDesign = breakpointNewDesign;
      }

      if (this.state.orientation !== orientation) {
        newState.orientation = orientation;
      }

      if (this.state.dimensions !== dimensions) {
        newState.dimensions = dimensions;
      }

      newState.isPrint = isPrint;

      this.setState(newState, () => this.forceUpdate());
    });
  }

  componentWillUnmount() {
    ResizeManager.unsubscribe(this.state.key);
  }

  render() {
    return (
      <ComposedComponent
        { ...this.props }
        isPrint={ this.state.isPrint }
        breakpoint={ this.state.breakpoint }
        breakpointNewDesign={ this.state.breakpointNewDesign }
        orientation={ this.state.orientation }
        dimensions={ this.state.dimensions } />
    );
  }
};
